module.exports = __webpack_public_path__ + "static/media/event_1.38ae3fdd.jpg";